import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import LeftNav from "pages/Member/LeftNav";
import { useQuery } from "@tanstack/react-query";
import { BankApi } from "states/api/bank";
import { useNavigate } from "react-router-dom";

const BankAddressDesktop = observer(() => {
  const navigate = useNavigate();
  const {
    authStore: { user },
  } = useStores();

  const { data, refetch } = useQuery(
    ["bank", "list"],
    () =>
      BankApi.getList({
        params: {
          page: 1,
          limit: 50,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
  }, []);

  return (
    <main className="css-1wr4jig">
      <main className="css-xry4yv !flex-row">
        <LeftNav />
        <div className="css-1wr4jig">
          <div className="css-1u0m1fa">
            <div className="css-fhl5lc">
              <span className="css-1cdfkn6">Quản lý địa chỉ mẫu</span>
            </div>
          </div>
          <div className="css-1bbywci">
            <div className="css-1pl31wt">
              <div className="css-k2y2sp">
                <div className="css-1868gi1">Quản lý địa chỉ</div>
              </div>
            </div>
            <div className="css-z32tht">
              <div className="css-joa6mv" />
              <div className="css-1op9i22">
                <div className="rc-table css-xdf65a rc-table-scroll-horizontal">
                  <div className="rc-table-container">
                    <div className="rc-table-content overflow-auto overflow-hidden">
                      <table className="w-[970px] min-w-full table-auto">
                        <thead className="rc-table-thead">
                          <tr>
                            <th className="rc-table-cell">Tên ngân hàng</th>
                            <th className="rc-table-cell">Tên</th>
                            <th className="rc-table-cell">Số tài khoản</th>
                          </tr>
                        </thead>
                        <tbody className="rc-table-tbody">
                          {data?.data?.length > 0 ? (
                            data?.data?.map((item) => (
                              <tr className="rc-table-row rc-table-row-level-0">
                                <td className="rc-table-cell">
                                  <div className="css-15oyuc7">
                                    <div className="css-1c82c04">
                                      <div className="css-1c82c04">
                                        {item?.bank_name}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="rc-table-cell">
                                  <div className="css-15oyuc7">
                                    <div className="css-16sm7a0">
                                      <div className="css-1c82c04">
                                        {item?.bank_owner}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="rc-table-cell">
                                  <div className="css-15oyuc7">
                                    <div className="css-1f9551p">
                                      <div className="css-1c82c04">
                                        {item?.bank_number_display}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr className="rc-table-row rc-table-row-level-0">
                              <td colSpan={3}>
                                <div
                                  className="btn !w-[170px] mx-auto"
                                  onClick={() =>
                                    navigate(
                                      "/member/bank/submit?bank_type=local"
                                    )
                                  }
                                >
                                  Thêm ngân hàng
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </main>
  );
});

export default BankAddressDesktop;
